<template>
  <v-container class="h-100 container-service-rate">
    <v-row align="center" align-content="center" justify="center" class="pb-8">
      <!-- <div class="col-12 text-center text-service-rate pb-8">อัตราค่าบริการ</div> -->
      <v-data-table
        :headers="headers"
        :items="data"
        :items-per-page="10"
        mobile-breakpoint="0"
        class="elevation-1 table-service-rate v-table"
        hide-default-footer
      >
        <template v-slot:[`item.action`]="{}">
          <v-btn color="#6CB549" class="text-white" small elevation="4" rounded @click="gotoPayment()" dark>สมัครใช้งาน</v-btn>
        </template>
      </v-data-table>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data () {
    return {
      headers: [
        { text: 'จำนวนการใช้บริการ/เดือน', align: 'center', sortable: false, value: 'Transactions', width: '30%'},
        { text: 'ราคา (บาท)', value: 'price', align: 'center', width: '40%', sortable: false },
        { text: '', value: 'action', align: 'center', width: '30%', sortable: false }
      ],
      data: [
        { Transactions: '300', price: '900'},
        { Transactions: '500', price: '1,300'},
        { Transactions: '1,000', price: '2,400'},
        { Transactions: '3,500', price: '7,000'},
        { Transactions: '7,500', price: '13,000'},
        { Transactions: '10,000', price: '15,000'},
        { Transactions: '25,000', price: '20,000'},
        { Transactions: '50,000', price: '35,000'},
        { Transactions: '100,000', price: '64,000'},
        { Transactions: '300,000', price: '130,000'}
      ]
    }
  }
}
</script>

<style scoped>
.text-service-rate {
  color: #474554;
  font-size: 40px;
  font-weight: 500;
}
.container-service-rate {
  width: 100% !important;
  overflow: auto;
  max-width: 100%;
  height: 100%;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* background: url("../../assets/bg-home2.jpg") no-repeat; */
  background-size: cover;
  background-blend-mode: soft-light;
  /* padding-bottom: 0px; */
  padding-top: 100px;
}
.table-service-rate {
  width: 40%;
}
.v-table {
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
}
.v-table ::v-deep th {
  font-size: 14px !important;
}
.table-service-rate ::v-deep th.text-center {
  background-color: #6CB549;
  color: white !important;
  font-size: 14px;
  font-weight: 500;
}
.table-service-rate ::v-deep tr:nth-child(even) {
  /* background-color: #FDEAE8; */
}
.table-service-rate ::v-deep thead th:first-child {
  border-radius: 10px 0 0 0;
}
.table-service-rate ::v-deep thead th:last-child {
  border-radius: 0 10px 0 0;
}
@media screen and (max-width: 959px) {
  .table-service-rate {
    width: 80%;
  }
  .container-service-rate {
    width: 100% !important;
    overflow: auto;
    max-width: 100%;
    height: 100%;
    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    /* background: url("../../assets/bg-home2.jpg") no-repeat; */
    background-size: cover;
    background-blend-mode: soft-light;
    /* padding-bottom: 60px; */
    padding-top: 120px;
  }
  .v-table {
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
  }
  .v-table ::v-deep .v-data-footer {
    justify-content: end;
  }
}
</style>